__turbopack_context__.v({
  "avoidLabel": "type-module__w2ER5q__avoidLabel",
  "avoidNote": "type-module__w2ER5q__avoidNote",
  "bridgeLink": "type-module__w2ER5q__bridgeLink",
  "bridgeSeasonLink": "type-module__w2ER5q__bridgeSeasonLink",
  "bridgeSeasonRow": "type-module__w2ER5q__bridgeSeasonRow",
  "celebCard": "type-module__w2ER5q__celebCard",
  "celebDesc": "type-module__w2ER5q__celebDesc",
  "celebName": "type-module__w2ER5q__celebName",
  "charColumn": "type-module__w2ER5q__charColumn",
  "charSubhead": "type-module__w2ER5q__charSubhead",
  "ctaBand": "type-module__w2ER5q__ctaBand",
  "ctaBandSlim": "type-module__w2ER5q__ctaBandSlim",
  "ctaHeadline": "type-module__w2ER5q__ctaHeadline",
  "ctaSubtitle": "type-module__w2ER5q__ctaSubtitle",
  "dashItem": "type-module__w2ER5q__dashItem",
  "dashList": "type-module__w2ER5q__dashList",
  "dashMark": "type-module__w2ER5q__dashMark",
  "editorialList": "type-module__w2ER5q__editorialList",
  "editorialListItem": "type-module__w2ER5q__editorialListItem",
  "faceCaptionList": "type-module__w2ER5q__faceCaptionList",
  "faceCaptionNumber": "type-module__w2ER5q__faceCaptionNumber",
  "faceDot": "type-module__w2ER5q__faceDot",
  "faceImageWrap": "type-module__w2ER5q__faceImageWrap",
  "hairCard": "type-module__w2ER5q__hairCard",
  "hairCardImage": "type-module__w2ER5q__hairCardImage",
  "hairCardName": "type-module__w2ER5q__hairCardName",
  "hairCardWhy": "type-module__w2ER5q__hairCardWhy",
  "hairScroll": "type-module__w2ER5q__hairScroll",
  "hairline": "type-module__w2ER5q__hairline",
  "heightBand": "type-module__w2ER5q__heightBand",
  "heightRangeLabel": "type-module__w2ER5q__heightRangeLabel",
  "heightTick": "type-module__w2ER5q__heightTick",
  "heightTickCm": "type-module__w2ER5q__heightTickCm",
  "heightTickFt": "type-module__w2ER5q__heightTickFt",
  "heightTicks": "type-module__w2ER5q__heightTicks",
  "heightTrack": "type-module__w2ER5q__heightTrack",
  "hero": "type-module__w2ER5q__hero",
  "heroImageWrap": "type-module__w2ER5q__heroImageWrap",
  "heroKicker": "type-module__w2ER5q__heroKicker",
  "heroStat": "type-module__w2ER5q__heroStat",
  "heroStatLabel": "type-module__w2ER5q__heroStatLabel",
  "heroStatValue": "type-module__w2ER5q__heroStatValue",
  "heroStats": "type-module__w2ER5q__heroStats",
  "heroTagline": "type-module__w2ER5q__heroTagline",
  "heroTitle": "type-module__w2ER5q__heroTitle",
  "keyTellItem": "type-module__w2ER5q__keyTellItem",
  "keyTellLabel": "type-module__w2ER5q__keyTellLabel",
  "kicker": "type-module__w2ER5q__kicker",
  "lede": "type-module__w2ER5q__lede",
  "ledeRest": "type-module__w2ER5q__ledeRest",
  "lookDescription": "type-module__w2ER5q__lookDescription",
  "lookImage": "type-module__w2ER5q__lookImage",
  "lookImageCol": "type-module__w2ER5q__lookImageCol",
  "lookKicker": "type-module__w2ER5q__lookKicker",
  "lookName": "type-module__w2ER5q__lookName",
  "lookRow": "type-module__w2ER5q__lookRow",
  "lookRowReversed": "type-module__w2ER5q__lookRowReversed",
  "lookTextCol": "type-module__w2ER5q__lookTextCol",
  "numberFigure": "type-module__w2ER5q__numberFigure",
  "numberedItem": "type-module__w2ER5q__numberedItem",
  "numberedItemMuted": "type-module__w2ER5q__numberedItemMuted",
  "numberedItemText": "type-module__w2ER5q__numberedItemText",
  "numberedList": "type-module__w2ER5q__numberedList",
  "paletteRow": "type-module__w2ER5q__paletteRow",
  "piecesLabel": "type-module__w2ER5q__piecesLabel",
  "plainCard": "type-module__w2ER5q__plainCard",
  "plainCardTitle": "type-module__w2ER5q__plainCardTitle",
  "sectionTitle": "type-module__w2ER5q__sectionTitle",
  "serif": "type-module__w2ER5q__serif",
  "swatch": "type-module__w2ER5q__swatch",
  "swatchCircle": "type-module__w2ER5q__swatchCircle",
  "swatchName": "type-module__w2ER5q__swatchName",
  "tellBlock": "type-module__w2ER5q__tellBlock",
});
